import { useTranslation } from '@flecto/translations'
import { type CoreBooking } from '@flecto/types'
import { Badge, type BadgeProps } from '@flecto/ui'

export type BadgeBookingInsuranceStatusProps = Omit<BadgeProps, 'children'> & {
  booking?: CoreBooking
}

export function BadgeBookingInsuranceStatus({
  booking,
  ...props
}: BadgeBookingInsuranceStatusProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'bookings' })

  if (!booking) {
    return null
  }

  return (
    <Badge {...props} color={booking.insured ? 'green' : 'gray'}>
      {booking.insured ? t('label_enabled') : t('label_disabled')}
    </Badge>
  )
}
